import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import {
  CourseTestTranslationsSchema,
  TEST_COOLDOWN_HOURS_MAX,
  TEST_PASSING_SCORE_MAX_PCT,
  TEST_PASSING_SCORE_MIN_PCT,
  TestAttemptsAllowedSchema,
} from '../test/test';

/**
 * The editable half of a test.
 *
 * **`courseId` is here and it is settable on create only**, which the update
 * schema enforces by simply not carrying it. Moving a
 * test between courses after members have sat it would silently re-point every
 * `course_completion` rule that named it, and re-decide matrix row 3 for
 * attempts already taken.
 */
export const CourseTestWritableShape = {
  passingScorePct: z.number().int().min(TEST_PASSING_SCORE_MIN_PCT).max(TEST_PASSING_SCORE_MAX_PCT),
  attemptsAllowed: TestAttemptsAllowedSchema,
  cooldownHours: z.number().int().min(0).max(TEST_COOLDOWN_HOURS_MAX),
  isActive: z.boolean(),
  translations: CourseTestTranslationsSchema,
};

/** Creating a test (`courses.manage`). `courseId` null is a standalone test (row 4). */
export const CourseTestCreateSchema = z
  .object({
    courseId: UuidSchema.nullable(),
    ...CourseTestWritableShape,
  })
  .strict();

export type CourseTestCreateRequest = z.infer<typeof CourseTestCreateSchema>;
